<script>
    import {notifier} from "@beyonk/svelte-notifications";
    import Loader from '../../Loader.svelte';

    export let assessment;
    export let assessment_model;
    export let section;

    let section_data;

    function save() {
        assessment_model.saveSectionResults(section, section_data).then(() => {
            notifier.success("Report Section Saved")
        });
    }

    function load_data(assessment) {
        if (!assessment) return

        if (assessment.report_data[section.section_name]) {
            section_data = assessment.report_data[section.section_name]
        } else {
           section_data = {
               scores: []
           };

           for (let category of section.categories) {
               let category_results = {
                   name: category.name,
                   items: []
               }
               for (let item of category.items) {
                   category_results.items.push({
                       name: item.name,
                       score: item.default_score,
                       target: item.default_target
                   })
               }

               section_data.scores.push(category_results)
           }
        }
    }

    $: load_data($assessment);
</script>

<Loader loading={section_data == undefined}>
    <button class="button is-success is-pulled-right" on:click={save}>Save</button>
    <div class="columns">
        <div class="column">
            <table class="table is-fullwidth">
                <thead>
                    <tr>
                        <th>Category</th>
                        <th>Item</th>
                        <th>Target Score</th>
                        <th>Client Score</th>
                        <th>Target Average</th>
                        <th>Client Average</th>
                    </tr>
                </thead>
                <tbody>
                    {#each section_data.scores as category}
                        {#each category.items as item, idx}
                            <tr>
                                {#if idx == 0}
                                    <td class="is-v-centered is-h-centered" rowspan={category.items.length}>{category.name}</td>
                                {/if}
                                <td>{item.name}</td>
                                <td>
                                    <input type="number" min=1 max=5 step=0.1 tabindex="1" bind:value={item.target}>
                                </td>
                                <td>
                                    <input type="number" min=1 max=5 step=0.1 tabindex="2" bind:value={item.score}>
                                </td>
                                {#if idx == 0}
                                    <td class="is-v-centered is-h-centered" rowspan={category.items.length}>
                                        {(category.items.map(s => s.target).reduce((a,b) => a + b) / category.items.length).toPrecision(3)}
                                    </td>
                                    <td class="is-v-centered is-h-centered" rowspan={category.items.length}>
                                        {(category.items.map(s => s.score).reduce((a,b) => a + b) / category.items.length).toPrecision(3)}
                                    </td>
                                {/if}
                            </tr>
                        {/each}
                    {/each}
                </tbody>
            </table>
        </div>
        <div class="column">
            <table class="table is-size-6">
                <thead><tr><th colspan=2>Capability Maturity Model Scoring</th></tr></thead>
                <tbody>
                    <tr>
                        <th>
                            Level 5: Optimizing	
                        </th>
                        <td>
                            <ul>
                                <li>
                                    Policies, procedures and processes are consistently implemented across the enterprise.
                                </li>
                                <li>
                                    Evidence can be provided for all activities and detailed metrics of the process are captured and reported.
                                </li>
                                <li>
                                    High reliance on tools and automation with optimized technology are used to make risk based decisions.
                                </li>
                                <li>
                                    Security measurably enables the organization to reach its strategic goals.
                                </li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            Level 4: Managed
                        </th>
                        <td>
                            <ul>
                                <li>
                                    The program is measured, controlled and mapped to business risks.
                                </li>
                                <li>
                                    Processes are repeatable and effectiveness is measured against defined requirements over time.
                                </li>
                                <li>
                                    Tools are integrated and support automation of workflows, processes and controls.
                                </li>
                                <li>
                                    Metrics are collected, analyzed and reported.
                                </li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            Level 3: Defined
                        </th>
                        <td>
                            <ul>
                                <li>
                                    Organization-wide policies, processes and standards exist with formal adoption and funding.
                                </li>
                                <li>
                                    Procedures and controls have been documented and implemented to support governance structure.
                                </li>
                                <li>
                                    Alignment to business risk relies on qualitative rather than quantitative measurement.
                                </li>
                                <li>
                                    Tools to support automation and enforcement of policies is underway.
                                </li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            Level 2: Developing
                        </th>
                        <td>
                            <ul>
                                <li>
                                    Policies, processes, standards and metrics are being developed.
                                </li>
                                <li>
                                    Responsibilities have been defined and assigned.
                                </li>
                                <li>
                                    Some tools have been deployed to support processes.
                                </li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <th>
                            Level 1: Initial
                        </th>
                        <td>
                            <ul>
                                <li>
                                    Policy or process may exist but is largely ad-hoc.
                                </li>
                                <li>
                                    Risk management processes are unpredictable and reactive.
                                </li>
                                <li>
                                    Limited executive engagement or support.
                                </li>
                            </ul>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</Loader>